// material-ui
import { Theme, alpha } from '@mui/material/styles';
// types
import { CustomGradientProps } from 'types/theme';
import { ThemeMode } from 'config';

// Cores Salamander - Versão clara
const SALAMANDER_LIGHT = '#E8F5E9'; // Verde muito claro, quase branco
const SALAMANDER_VERY_LIGHT = '#F1F8F4'; // Verde extremamente claro
const WHITE = '#FFFFFF';

// ==============================|| CUSTOM GRADIENTS (SALAMANDER) ||============================== //
export default function CustomGradients(theme: Theme): CustomGradientProps {
  const isDark = theme.palette.mode === ThemeMode.DARK;

  // Fundo da aplicação - Tom muito claro, quase branco com leve toque verde
  const diagonal = `
    linear-gradient(
      160deg,
      ${WHITE} 0%,
      ${SALAMANDER_VERY_LIGHT} 45%,
      ${SALAMANDER_LIGHT} 100%
    )`;

  // Superfícies (Sidebar/Paper/Card): Branco com leve toque verde translúcido
  const paperDiag = `
    linear-gradient(
      165deg,
      ${alpha(WHITE, isDark ? 0.95 : 0.98)} 0%,
      ${alpha(SALAMANDER_VERY_LIGHT, isDark ? 0.90 : 0.95)} 100%
    )`;

  // AppBar/Toolbars: Branco com leve toque verde
  const toolbarDiag = `
    linear-gradient(
      165deg,
      ${alpha(WHITE, 0.98)} 0%,
      ${alpha(SALAMANDER_VERY_LIGHT, 0.95)} 55%,
      ${alpha(SALAMANDER_LIGHT, 0.92)} 100%
    )`;

  return {
    appBg: diagonal,
    paperBg: paperDiag,
    toolbarBg: toolbarDiag
  };
}

